/**
 * Creates HTML Markup from string
 * @param encodedString
 */
export function createMarkup(encodedString) {
    if (encodedString.includes('mime_type')) {
        /** Its a vital metafield with another format */
        try {
            const imageData = JSON.parse(encodedString.replace(/=>/gi, ':'));
            const image = imageData[0];
            if (image) {
                return {
                    __html: `<img src="${image.cloudinary_src}" >`,
                };
            }
        }
        catch (error) {
            console.log(error);
            return {
                __html: '<span/>',
            };
        }
    }
    else {
        return {
            __html: encodedString,
        };
    }
}
